/**
 * @generated SignedSource<<5671c02cdc14846f45489a62b41b11fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type archivePlusArchiveQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"betweenTheLinesPlusArchiveQuery" | "chinaFutureTechBriefingsPlusArchiveQuery" | "dailyPulsePlusArchiveQuery" | "factSheetPlusArchiveQuery" | "interactivesPlusArchiveQuery" | "openQuestionsSeriesPlusArchiveQuery" | "quickDigestPlusArchiveQuery">;
  readonly " $fragmentType": "archivePlusArchiveQuery";
};
export type archivePlusArchiveQuery$key = {
  readonly " $data"?: archivePlusArchiveQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"archivePlusArchiveQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "betweenTheLinesTypeUuid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "chinaFutureTechBriefingsTypeUuid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dailyPulseTypeUuid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "factSheetTypeUuid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "openQuestionsSeriesTypeUuid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "quickDigestTypeUuid"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "archivePlusArchiveQuery",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "dailyPulseTypeUuid",
          "variableName": "dailyPulseTypeUuid"
        }
      ],
      "kind": "FragmentSpread",
      "name": "dailyPulsePlusArchiveQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "chinaFutureTechBriefingsTypeUuid",
          "variableName": "chinaFutureTechBriefingsTypeUuid"
        }
      ],
      "kind": "FragmentSpread",
      "name": "chinaFutureTechBriefingsPlusArchiveQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "factSheetTypeUuid",
          "variableName": "factSheetTypeUuid"
        }
      ],
      "kind": "FragmentSpread",
      "name": "factSheetPlusArchiveQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "quickDigestTypeUuid",
          "variableName": "quickDigestTypeUuid"
        }
      ],
      "kind": "FragmentSpread",
      "name": "quickDigestPlusArchiveQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "openQuestionsSeriesTypeUuid",
          "variableName": "openQuestionsSeriesTypeUuid"
        }
      ],
      "kind": "FragmentSpread",
      "name": "openQuestionsSeriesPlusArchiveQuery"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "betweenTheLinesTypeUuid",
          "variableName": "betweenTheLinesTypeUuid"
        }
      ],
      "kind": "FragmentSpread",
      "name": "betweenTheLinesPlusArchiveQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "interactivesPlusArchiveQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "75a4591be4d0eaa155ddcee837e0083f";

export default node;
